var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchButton26X26 = function SvgSearchButton26X26(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.012,
    cy: 11.012,
    r: 4.272,
    stroke: "#1C3033",
    transform: "rotate(-90 11.012 11.012)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C3033",
    d: "m14.668 13.963 4.405 4.405"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#1C3033"
  })));
};
export default SvgSearchButton26X26;